import React, { Component } from 'react';
import IconeSobrescrito from './IconeSobrescrito';
import { Error } from '@mui/icons-material';

interface IPropsIconeErroSobrescrito {
}


export default class IconeErroSobrescrito extends React.Component<IPropsIconeErroSobrescrito> {


    render() {
        return (
            <IconeSobrescrito>
                <Error />
            </IconeSobrescrito>
        );
    }
}
